import Badge from 'react-bootstrap/Badge';
import '../index.scss';
import {
  AddSpaceBetweenKey,
  inNetworkDetailsList,
  outNetworkDetailsList,
  penaltyDetailsList,
} from '../../../../../Member/utils/Coverage';
import { Row, Col } from 'react-bootstrap';
import Skeleton from './skeleton/GenericSkeleton';
import APIEndpoints from 'src/Member/api/APIEndpoints';
import { axiosInstance } from '../../../../../api/axios';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import base64url from 'base64url';
import CopaymentNetwrok from './CopaymentNetwrok';
import httpheader from 'src/Admin/shared/httpheader';

export const CostCards = (PlanInfo) => {
  const cName = httpheader.getCNAME();
  const [dataFetching, setDataFetching] = useState(false);
  const [isNotFound, setIsNotFound] = useState(false);
  const [isAPIFailed, setIsAPIFailed] = useState(false);
  const [inCoverageCopayments, setInCoverageCopayments] = useState();
  const [outCoverageCopayments, setOutInCoverageCopayments] = useState();
  const [outOfNetworkFlag, setOutOfNetworkFlag] = useState();
  const [inOfNetworkFlag, setInOfNetworkFlag] = useState();
  const [penaltyFlag, setPenaltyFlag] = useState();
  const [penaltyCoverageCopayments, setPenaltyCoverageCopayments] = useState();
  const [inCoverageCopaymentsTier, setInCoverageCopaymentsTier] = useState();
  const [inOfNetworkFlagTier, setInOfNetworkFlagTier] = useState();

  const {
    BenefitPlan,
    MasterId,
    PlanEffectiveDate,
    activeCoverageType,
    activeMemType,
    activeOID,
    benefitYear,
    networkProps,
    CurrentActive,
    isFamilySelected,
    selectedUser,
    networkPlandetails,
    selectedTier,
    ...other
  } = PlanInfo.PlanInfo;
  const { BenefitID, BenefitText, ServiceTypeCode } =
    PlanInfo.coveredservicesDetails;
  const {
    Display_Penalty_OR_OutOfNetwork,
    Display_Tier_Network_Detailed_View,
  } =
    useSelector((state) => state.app.appConfigs.Network_Setting) ||
    'Out-Of-Network';
  const getYearAndStartDate = (selectedBenefitYear) => {
    const returnData = {
      yearName: '',
      yearStartDate: '',
    };
    if ((selectedBenefitYear + '').length === 4) {
      returnData.yearName = selectedBenefitYear;
      returnData.yearStartDate = 'DED';
    } else {
      const dateInfo = selectedBenefitYear.split(' - ')[0];
      returnData.yearStartDate = dateInfo;
      returnData.yearName = dateInfo.split('-')[0];
    }
    return returnData;
  };
  const coverageExceptionsConfiguration = async () => {
    setIsAPIFailed(false);
    console.log(BenefitID, BenefitText, ServiceTypeCode, 'benefits codesss');
    if (networkProps !== 'null') {
      try {
        const penaltyFlag =
          Display_Penalty_OR_OutOfNetwork === 'Out-Of-Network' ||
          PlanInfo.PlanInfo.displayTierFromOutOfNetwork
            ? false
            : true;
        const tierFlag = selectedTier.value === -2 ? true : false;
        const { yearName, yearStartDate } = getYearAndStartDate(benefitYear);
        const queryString = `memberType/${activeMemType}/oid/${activeOID}/producttype/${activeCoverageType}/benefitplan/${btoa(
          BenefitPlan,
        )}/planYear/${yearName}/masterid/${MasterId}/network/${
          networkProps.value
        }/benefitid/${BenefitID}/benefittext/${BenefitText}/servicetypecode/${
          ServiceTypeCode ? ServiceTypeCode : null
        }/planeffectivedate/${PlanEffectiveDate}/planyearstartdate/${yearStartDate}/penaltyflag/${penaltyFlag}/excludeooa/false`;

        const queryStringTier = `memberType/${activeMemType}/oid/${activeOID}/producttype/${activeCoverageType}/benefitplan/${btoa(
          BenefitPlan,
        )}/planYear/${yearName}/masterid/${MasterId}/network/${
          selectedTier.value === -2 ? networkProps.value : selectedTier.value
        }/benefitid/${BenefitID}/benefittext/${BenefitText}/servicetypecode/${
          ServiceTypeCode ? ServiceTypeCode : null
        }/planeffectivedate/${PlanEffectiveDate}/planyearstartdate/${yearStartDate}/penaltyflag/${tierFlag}/excludeooa/${!tierFlag}`;

        const coverageExceptionsConfiguration = await axiosInstance.get(
          APIEndpoints.getCoverageExceptionsConfiguration() + queryString,
        );
        console.log(coverageExceptionsConfiguration);
        const CoveredExceptionData =
          coverageExceptionsConfiguration?.data?.Response;
        const inNetworkInfo = inNetworkDetailsList(
          CoveredExceptionData,
          isFamilySelected,
        );
        console.log(inNetworkInfo, 'InNetworkInformation');

        const outNetworkInfo = outNetworkDetailsList(
          CoveredExceptionData,
          isFamilySelected,
        );
        console.log(outNetworkInfo, 'OutNetworkInformation');

        let penaltyInfo = penaltyDetailsList(
          CoveredExceptionData,
          isFamilySelected,
        );
        console.log(penaltyInfo, 'Penalty Information');

        if (Display_Tier_Network_Detailed_View === true) {
          if (selectedTier.value !== -1) {
            const coverageExceptionsConfigurationTier = await axiosInstance.get(
              APIEndpoints.getCoverageExceptionsConfiguration() +
                queryStringTier,
            );
            console.log(coverageExceptionsConfiguration);
            const CoveredExceptionDataTier =
              coverageExceptionsConfigurationTier?.data?.Response;

            const inNetworkInfoTier = inNetworkDetailsList(
              CoveredExceptionDataTier,
              isFamilySelected,
            );
            console.log(inNetworkInfoTier, 'inNetworkInfoTier');
            penaltyInfo = penaltyDetailsList(
              CoveredExceptionDataTier,
              isFamilySelected,
            );
            console.log(penaltyInfo, 'Penalty Information');
            setInCoverageCopaymentsTier(inNetworkInfoTier);
            setInOfNetworkFlagTier(inNetworkInfoTier?.inNetworkExclusionFlag);
          } else {
            if (selectedTier.label === 'Out Of Network') {
              setInCoverageCopaymentsTier(outNetworkInfo);
              setInOfNetworkFlagTier(outNetworkInfo?.outNetworkExclusionFlag);
            } else {
              setInOfNetworkFlagTier(penaltyInfo.penaltyExclusionFlag);
              setInCoverageCopaymentsTier(penaltyInfo);
            }
          }
        }

        setInCoverageCopayments(inNetworkInfo);
        setInOfNetworkFlag(inNetworkInfo?.inNetworkExclusionFlag);
        setOutInCoverageCopayments(outNetworkInfo);
        setOutOfNetworkFlag(outNetworkInfo?.outNetworkExclusionFlag);
        setPenaltyFlag(penaltyInfo.penaltyExclusionFlag);
        setPenaltyCoverageCopayments(penaltyInfo);
        //const ServiceDetails = CoveredExceptionData?.servicesjson?.Response;
        setDataFetching(false);
      } catch (error) {
        setDataFetching(false);
        if (error.toString().includes('404')) {
          setIsNotFound(true);
        }
        if (error.toString().includes('500')) {
          setIsNotFound(true);
        }
        setIsAPIFailed(true);
      }
    }
  };
  useEffect(() => {
    if (
      PlanInfo.coveredservicesDetails.ServiceType ===
        PlanInfo.currentActiveTab &&
      !PlanInfo.dataFetching
    ) {
      setDataFetching(true);
      coverageExceptionsConfiguration();
    }
  }, [
    networkProps.value,
    benefitYear,
    activeOID,
    selectedTier.value,
    PlanInfo?.currentActiveTab,
  ]);
  return (
    <>
      <Row className="mt-2">
        <Col md={4} className="mb-3 mb-md-0">
          <div className="cost-cards">
            {PlanInfo.PlanInfo.displayTierFromOutOfNetwork ? (
              <CopaymentNetwrok
                coverageCopayments={outCoverageCopayments}
                NetworkExclusionFlag={outOfNetworkFlag}
                network={'Out of Network'}
                isNotFound={isNotFound}
                isAPIFailed={isAPIFailed}
                dataFetching={dataFetching}
                networkPlandetails={networkPlandetails}
                BenefitPlan={BenefitPlan}
              />
            ) : (
              <CopaymentNetwrok
                coverageCopayments={inCoverageCopayments}
                network={'In Network'}
                NetworkExclusionFlag={inOfNetworkFlag}
                isNotFound={isNotFound}
                isAPIFailed={isAPIFailed}
                dataFetching={dataFetching}
                networkProps={networkProps}
                BenefitPlan={BenefitPlan}
              />
            )}
          </div>
        </Col>
        {!other.hideSecondCard && (
          <>
            {Display_Tier_Network_Detailed_View === true ? (
              <>
                <Col md={4} className="mb-3 mb-md-0">
                  <div className="cost-cards">
                    {selectedTier.value === -2 ? (
                      <CopaymentNetwrok
                        coverageCopayments={penaltyCoverageCopayments}
                        network={'Penalty'}
                        NetworkExclusionFlag={penaltyFlag}
                        isNotFound={isNotFound}
                        isAPIFailed={isAPIFailed}
                        dataFetching={dataFetching}
                        networkProps={networkProps}
                        label={selectedTier.label}
                        BenefitPlan={BenefitPlan}
                      />
                    ) : (
                      <CopaymentNetwrok
                        coverageCopayments={inCoverageCopaymentsTier}
                        network={'In Network'}
                        NetworkExclusionFlag={inOfNetworkFlagTier}
                        isNotFound={isNotFound}
                        isAPIFailed={isAPIFailed}
                        dataFetching={dataFetching}
                        networkProps={networkProps}
                        label={selectedTier.label}
                        BenefitPlan={BenefitPlan}
                      />
                    )}
                  </div>
                </Col>
              </>
            ) : (
              <>
                {Display_Penalty_OR_OutOfNetwork === 'Penalty' ? (
                  <Col md={4} className="mb-3 mb-md-0">
                    <div className="cost-cards">
                      <CopaymentNetwrok
                        coverageCopayments={penaltyCoverageCopayments}
                        NetworkExclusionFlag={penaltyFlag}
                        network={'Penalty'}
                        isNotFound={isNotFound}
                        isAPIFailed={isAPIFailed}
                        dataFetching={dataFetching}
                        networkPlandetails={networkPlandetails}
                        BenefitPlan={BenefitPlan}
                      />
                    </div>
                  </Col>
                ) : (
                  <Col md={4} className="mb-3 mb-md-0">
                    <div className="cost-cards">
                      <CopaymentNetwrok
                        coverageCopayments={outCoverageCopayments}
                        NetworkExclusionFlag={outOfNetworkFlag}
                        network={'Out of Network'}
                        isNotFound={isNotFound}
                        isAPIFailed={isAPIFailed}
                        dataFetching={dataFetching}
                        networkPlandetails={networkPlandetails}
                        BenefitPlan={BenefitPlan}
                      />
                    </div>
                  </Col>
                )}
              </>
            )}
          </>
        )}
      </Row>
    </>
  );
};
